import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ListChecks, Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui-kit";
import { api, errorText } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";

export const RejectReasonsSettings = () => {
  const { t } = usePrefs();
  const [list, setList] = useState<string[] | null>(null);
  useEffect(() => { api.get("/admin/reject-reasons").then((r) => setList(r.data)).catch(() => setList([])); }, []);
  if (!list) return null;
  const save = async () => {
    try {
      setList((await api.put("/admin/reject-reasons", { reasons: list })).data);
      toast.success(t("rr.saved"));
    } catch (e) {
      toast.error(errorText(e, t));
    }
  };
  return (
    <div data-testid="reject-reasons-settings" className="rounded-3xl border bg-card p-5 space-y-3">
      <p className="font-bold flex items-center gap-2"><ListChecks className="h-5 w-5 text-primary" />{t("rr.title")}</p>
      <p className="text-sm text-muted-foreground">{t("rr.note")}</p>
      {list.map((r, i) => (
        <div key={i} className="flex gap-2">
          <Input value={r} maxLength={300} placeholder={t("rr.ph")} onChange={(e: any) => setList(list.map((x, j) => (j === i ? e.target.value : x)))} data-testid={`reject-reason-input-${i}`} className="h-10 rounded-full" />
          <button onClick={() => setList(list.filter((_, j) => j !== i))} data-testid={`reject-reason-delete-${i}`} aria-label="delete"
            className="h-10 w-10 shrink-0 rounded-full bg-primary/10 text-primary inline-flex items-center justify-center active:scale-95 transition-transform"><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      <div className="flex flex-wrap gap-2">
        {list.length < 20 && <button onClick={() => setList([...list, ""])} data-testid="reject-reason-add" className="h-10 px-4 rounded-full bg-accent text-sm font-bold inline-flex items-center gap-1.5 active:scale-95 transition-transform"><Plus className="h-4 w-4" />{t("rr.add")}</button>}
        <button onClick={save} data-testid="reject-reasons-save" className="h-10 px-5 rounded-full bg-primary text-primary-foreground text-sm font-bold active:scale-95 transition-transform">{t("common.save")}</button>
      </div>
    </div>
  );
};
